<template>
  <PageLoader v-if="isloading" />
  <HeadWithLogo/>
  <div class="mb-4">
    <p class="text-justify">
      در صورت علاقه مندی جهت ثبت نام در سامانه برخط ناظر یک
      لطفا فرم زیر را کامل فرمایید.
    </p>
    <span>لطفا فرم زیر را کامل فرمایید.</span><br>
    <span>نکات قبل از ثبت نام اولیه:</span><br>
    <span>1. تکمیل این فرم و انجام مراحل بعدی به منزله تایید نهایی نمی باشد و بایستی پس از تکمیل مراحل، پلیس امنیت عمومی نیروی انتظامی ثبت نام را تایید نماید.</span><br>
    <span>2. جهت تکمیل فرآیند ثبت نام، پس از پر کردن این فرم، مراحل بعد را دنبال بفرمایید.</span>
  </div>

  <Form @submit="onSubmit" class="text-end">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <label for="registerFirstName" class="form-label"><label class="star">*</label>نام</label>
        <Field name="registerFirstName" v-model="fname" type="text" class="form-control"
               :rules="isRequired"/>
        <ErrorMessage name="registerFirstName"/>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label for="registerLastName" class="form-label"><label class="star">*</label>نام خانوادگی</label>
        <Field name="registerLastName" type="text" v-model="lname" class="form-control"
               :rules="isRequired"/>
        <ErrorMessage name="registerLastName"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <div class="col-12">
          <label class="form-label"><label class="star">*</label>تاریخ تولد</label>
        </div>
        <div class="row cu-input">
          <div class="col-12 col-md-4 pt-2 pt-md-0">
            <Field as="select" name="rooz" v-model="birth_day" id="rooz" class="form-select"
                   :rules="selector">
              <option value="">روز</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>

            </Field>
            <ErrorMessage name="rooz"/>
          </div>
          <div class="col-12 col-md-4 pt-2 pt-md-0">
            <Field as="select" name="mah" id="mah" v-model="birth_month" class="form-select"
                   :rules="selector">
              <option value="">ماه</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>

            </Field>
            <ErrorMessage name="mah"/>
          </div>
          <div class="col-12 col-md-4 pt-2 pt-md-0">
            <Field as="select" name="sal" id="sal" v-model="birth_year" class="form-select"
                   :rules="selector">
              <option value="">سال</option>
              <option value="1310">1310</option>
              <option value="1311">1311</option>
              <option value="1312">1312</option>
              <option value="1313">1313</option>
              <option value="1314">1314</option>
              <option value="1315">1315</option>
              <option value="1316">1316</option>
              <option value="1317">1317</option>
              <option value="1318">1318</option>
              <option value="1319">1319</option>
              <option value="1320">1320</option>
              <option value="1321">1321</option>
              <option value="1322">1322</option>
              <option value="1323">1323</option>
              <option value="1324">1324</option>
              <option value="1325">1325</option>
              <option value="1326">1326</option>
              <option value="1327">1327</option>
              <option value="1328">1328</option>
              <option value="1329">1329</option>
              <option value="1330">1330</option>
              <option value="1331">1331</option>
              <option value="1332">1332</option>
              <option value="1333">1333</option>
              <option value="1334">1334</option>
              <option value="1335">1335</option>
              <option value="1336">1336</option>
              <option value="1337">1337</option>
              <option value="1338">1338</option>
              <option value="1339">1339</option>
              <option value="1340">1340</option>
              <option value="1341">1341</option>
              <option value="1342">1342</option>
              <option value="1343">1343</option>
              <option value="1344">1344</option>
              <option value="1345">1345</option>
              <option value="1346">1346</option>
              <option value="1347">1347</option>
              <option value="1348">1348</option>
              <option value="1349">1349</option>
              <option value="1350">1350</option>
              <option value="1351">1351</option>
              <option value="1352">1352</option>
              <option value="1353">1353</option>
              <option value="1354">1354</option>
              <option value="1355">1355</option>
              <option value="1356">1356</option>
              <option value="1357">1357</option>
              <option value="1358">1358</option>
              <option value="1359">1359</option>
              <option value="1360">1360</option>
              <option value="1361">1361</option>
              <option value="1362">1362</option>
              <option value="1363">1363</option>
              <option value="1364">1364</option>
              <option value="1365">1365</option>
              <option value="1366">1366</option>
              <option value="1367">1367</option>
              <option value="1368">1368</option>
              <option value="1369">1369</option>
              <option value="1370">1370</option>
              <option value="1371">1371</option>
              <option value="1372">1372</option>
              <option value="1373">1373</option>
              <option value="1374">1374</option>
              <option value="1375">1375</option>
              <option value="1376">1376</option>
              <option value="1377">1377</option>
              <option value="1378">1378</option>
              <option value="1379">1379</option>
              <option value="1380">1380</option>
              <option value="1381">1381</option>
              <option value="1382">1382</option>
              <option value="1383">1383</option>
              <option value="1384">1384</option>
              <option value="1385">1385</option>
              <option value="1386">1386</option>
              <option value="1387">1387</option>
              <option value="1388">1388</option>
              <option value="1389">1389</option>
              <option value="1390">1390</option>
              <option value="1391">1391</option>
              <option value="1392">1392</option>
              <option value="1393">1393</option>
              <option value="1394">1394</option>
              <option value="1395">1395</option>
              <option value="1396">1396</option>
              <option value="1397">1397</option>
              <option value="1398">1398</option>

            </Field>
            <ErrorMessage name="sal"/>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label for="registerSex" class="form-label"><label class="star">*</label>جنسیت</label>
        <Field as="select" name="registerSex" class="form-select" v-model="sex" :rules="selector">
          <option></option>
          <option value="male">آقا</option>
          <option value="female">خانم</option>
        </Field >
        <ErrorMessage name="registerSex" />
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label for="national_code" class="form-label"><label class="star">*</label>کد ملی</label>
        <Field type="number" class="form-control" v-model="nationalID" name="national_code" :rules="isRequired"/>
        <ErrorMessage name="national_code"/>
      </div>
      <div class="col-12 col-md-6 mb-3 cu-input">
        <label for="marital_status" class="form-label"><label class="star">*</label>وضعیت تاهل</label>
        <Field as="select" name="marital_status" class="form-select" v-model="taahol" :rules="selector">
          <option value=""></option>
          <option value="متاهل">متاهل</option>
          <option value="مجرد">مجرد</option>
        </Field>
        <ErrorMessage name="marital_status"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <label for="registerProvince" class="form-label"><label class="star">*</label>استان</label>
        <Field as="select" class="form-select" @change="handleChangeState()" v-model="state" name="registerProvince" :rules="selector">
          <option></option>
          <option v-for="st in states" :value="st.id">{{ st.name }}</option>
        </Field>
        <ErrorMessage name="registerProvince"/>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label for="registerCity" class="form-label"><label class="star">*</label>شهر</label>
        <Field as="select" class="form-select" v-model="city" name="registerCity" :rules="selector">
          <option></option>
          <option v-for="ct in cities" :value="ct.id">{{ ct.name }}</option>
        </Field>
        <ErrorMessage name="registerCity"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 pt-4">
        <label for="reagent_name" class="form-label"><label class="star">*</label>نام ونام خانوادگی معرف اول</label>
        <Field type="text" class="form-control" v-model="affiliate_fullname" name="reagent_name" :rules="isRequired"/>
        <ErrorMessage name="reagent_name"/>
      </div>
      <div class="col-12 col-md-6 pt-4">
        <label for="reagent_phone" class="form-label"><label class="star">*</label>تلفن همراه معرف اول</label>
        <Field type="number" class="form-control" v-model="affiliate_phone" name="reagent_phone" :rules="isRequired"/>
        <ErrorMessage name="reagent_phone"/>
      </div>
      <div class="col-12 col-md-6 pt-4">
        <label for="reagent_job" class="form-label"><label class="star">*</label>شغل معرف اول</label>
        <Field type="text" class="form-control" v-model="affiliate_job" name="reagent_job" :rules="isRequired"/>
        <ErrorMessage name="reagent_job"/>
      </div>
    </div>
  </Form>
  <div class="text-center mt-3">
    <span class="sp-danger"> در صورت وجود سوال یا اشکال، در پیام رسان واتساپ، ایتا و بله به شماره 09960936122 پیام دهید. </span>
  </div>
  <div class="row mt-3">
    <div class="col-6 text-end">
      <RouterLink to="/introFourth" class="btn btn-success px-3">
        صفحه قبل
      </RouterLink>
    </div>
    <div class="col-6 text-start">
      <button @click="handleSubmitStep2" class="btn btn-success px-3">صفحه بعد</button>
    </div>
  </div>
  <div class="text-center my-2 mt-3" v-for="error in errorMessage">
    <span class="text-danger mx-auto" ><b> {{ error[0] }}</b></span>
  </div>
  <div class="text-danger mx-auto mt-3" ><b>{{ errorMessage2 }}</b></div>
</template>
<style>
.control-label {
  font-size: 13px;
  margin-top: 10px;
}
</style>
<script>
import {Form, Field, ErrorMessage} from 'vee-validate';
import axios from 'axios';
import router from '@/router';
import PageLoader from '../components/Loader'
import HeadWithLogo from "@/components/HeadWithLogo";

export default {
  data() {
    return {
      birth_day: "",
      birth_month: "",
      birth_year: "",
      nationalID: "",
      taahol: "",
      affiliate_fullname: "",
      affiliate_phone: "",
      affiliate_job: "",
      fname: "",
      lname: "",
      sex: "",
      state: "",
      city: "",
      messages: "",
      errorMessage: "",
      errorMessage2: "",
      states:"",
      cities:"",
      isloading:false,
    }
  },
  components: {
    HeadWithLogo,
    Form,
    Field,
    ErrorMessage,
    PageLoader
  },
  mounted() {
    if (localStorage.name) {
      this.fullname = localStorage.name
    }
    if (!localStorage.token) {
      router.push('/PhoneNumber')
    }
    axios
      .get(process.env.VUE_APP_ROOT_API+'/api/getStates?api=sfFSadAs1432')
      .then(response => (this.states = response.data))
    
  },
  methods: {
    isRequired(value) {
      if (value && value.trim()) {
        return true;
      }
      return 'پر کردن فیلد الزامی است';
    },selector(value){
      if(value){
        return true;
      }
      return 'انتخاب مورد الزامی است';
    },
    handleSubmitStep2() {
      this.errorMessage=""
      this.errorMessage2=""
      this.isloading=true
      const headers = {
        accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.token
      }
      axios.get(process.env.VUE_APP_ROOT_API+"/sanctum/csrf-cookie").then(() => {
        axios
            .get(process.env.VUE_APP_ROOT_API+'/api/step2?name=' + this.fname + '&familyName=' +  this.lname + '&birthday=' + this.birth_day + '-' + this.birth_month + '-' + this.birth_year + '&sex=' + this.sex + '&nationalID=' + this.nationalID + '&taahol=' + this.taahol + '&state=' + this.state + '&city=' + this.city + '&affiliate_fullname=' + this.affiliate_fullname + '&affiliate_phone_number=' + this.affiliate_phone + '&affiliate_job=' + this.affiliate_job , {
              headers: headers
            })
            .then(response => {
              this.isloading=false
              this.messages = response.data
              if (this.messages.id >= 1) {
                localStorage.name = this.messages.name + " " + this.messages.family_name
                router.push("/rule-tutorial")
              } else {
                this.errorMessage2 = this.messages.message
              }
            })
            .catch((err) => {
              this.isloading=false
              this.errorMessage = err.response.data.errors
            })
      })
    },
    handleChangeState(){
      axios
        .get(process.env.VUE_APP_ROOT_API+'/api/getCities?api=sfFSadAs1432&state_id='+this.state)
        .then(response => (this.cities = response.data))
    }
  }
}
</script>
